const columns = [
  {
    title: "文件名称",
    key: "name",
    width: 80,
    dataIndex: "name",
  },
  {
    title: "文件类型",
    width: 80,
    key: "suffix",
    dataIndex: "suffix",
  },
  {
    title: "文件大小",
    width: 80,
    key: "size",
    slots: { customRender: "size" },
  },
  {
    title: "状态",
    width: 80,
    key: "status",
    slots: { customRender: "status" },
  },
  {
    title: "操作",
    width: 80,
    key: "action",
    slots: { customRender: "action" },
  },
];
export default columns;
